import { toast } from 'sonner';

import { resolveNotificationDeepLink } from '@/core/lib/notification-deep-link';

const RECENT_TOAST_IDS = new Map<string, number>();
const DEDUPE_MS = 5000;

export type ShowNotificationToastParams = {
  notificationId?: string;
  title: string;
  body?: string | null;
  deepLink?: string | null;
  viewLabel: string;
  onNavigate: (path: string) => void;
  onMarkRead?: (notificationId: string) => void | Promise<void>;
};

export function showNotificationToast({
  notificationId,
  title,
  body,
  deepLink,
  viewLabel,
  onNavigate,
  onMarkRead,
}: ShowNotificationToastParams): void {
  if (notificationId) {
    const now = Date.now();
    const lastShown = RECENT_TOAST_IDS.get(notificationId);
    if (lastShown !== undefined && now - lastShown < DEDUPE_MS) {
      return;
    }
    RECENT_TOAST_IDS.set(notificationId, now);
  }

  const resolvedDeepLink =
    typeof deepLink === 'string' && deepLink.trim()
      ? resolveNotificationDeepLink(deepLink)
      : null;

  toast.info(title, {
    description: body?.trim() || undefined,
    duration: 8000,
    action: resolvedDeepLink
      ? {
          label: viewLabel,
          onClick: () => {
            if (notificationId && onMarkRead) {
              void onMarkRead(notificationId);
            }
            onNavigate(resolvedDeepLink);
          },
        }
      : undefined,
  });
}
